<template>
  <div class="app-container">
    <div class="tabs-bg">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待清运" name="pending"></el-tab-pane>
        <el-tab-pane label="违规投递" name="violation"></el-tab-pane>
        <el-tab-pane label="正在清运" name="processing"></el-tab-pane>
        <el-tab-pane label="已发放" name="completed"></el-tab-pane>
        <el-tab-pane label="系统核查" name="auditing"></el-tab-pane>
        <el-tab-pane name="overweight">
          <span slot="label" style="color: #f56c6c;">大于5Kg</span>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="summary-bar">
      <div class="summary-header">
        <span class="dot"></span>
        <span class="title">基础信息概览</span>
      </div>
      <div class="summary-content">
        <div class="summary-item">
          <div class="value" style="color: #409EFF;">{{ totalDeliveries }}</div>
          <div class="label">总投递 (次)</div>
        </div>
        <div class="summary-item">
          <div class="value" style="color: #67C23A;">{{ totalWeight.toFixed(2) }}</div>
          <div class="label">总重量 (kg)</div>
        </div>
        <div class="summary-item">
          <div class="value" style="color: #F56C6C;">{{ abnormalDeliveries }}</div>
          <div class="label">违规投递 (次)</div>
        </div>
        <div class="summary-item">
          <div class="value" style="color: #E6A23C;">{{ totalAmount.toFixed(2) }}</div>
          <div class="label">总金额 (元)</div>
        </div>
      </div>
    </div>

    <div class="search-card">
      <el-form :inline="true" :model="searchParams" class="filter-form" size="small">
        <el-form-item>
          <el-input placeholder="用户编号" v-model="searchParams.user_id" clearable style="width: 100px;" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="用户手机号" v-model="searchParams.phone" clearable style="width: 110px;" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="最小重量(kg)" v-model="searchParams.min_weight" clearable type="number" style="width: 100px;" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="最大重量(kg)" v-model="searchParams.max_weight" clearable type="number" style="width: 100px;" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="设备编号" v-model="searchParams.device_code" clearable style="width: 110px;" />
        </el-form-item>
        <el-form-item>
          <el-input placeholder="设备名称" v-model="searchParams.box_name" clearable style="width: 110px;" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.group_id" placeholder="清运分组" clearable style="width: 100px;">
            <el-option v-for="g in boxGroups" :key="g.id" :label="(g.group_name || g.name)" :value="g.id" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.province_code" placeholder="选择省" clearable style="width: 90px;"
            @change="onProvinceSelect">
            <el-option v-for="p in provinces" :key="p.code" :label="p.name" :value="p.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.city_code" placeholder="选择市" clearable style="width: 90px;"
            @change="onCitySelect">
            <el-option v-for="c in cities" :key="c.code" :label="c.name" :value="c.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.area_code" placeholder="选择区" clearable style="width: 90px;"
            @change="onAreaSelect">
            <el-option v-for="a in areas" :key="a.code" :label="a.name" :value="a.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.street_code" placeholder="选择街道" clearable style="width: 100px;"
            @change="onStreetSelect">
            <el-option v-for="s in streets" :key="s.code" :label="s.name" :value="s.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchParams.community_code" placeholder="选择小区" clearable style="width: 100px;">
            <el-option v-for="cm in communities" :key="cm.code" :label="cm.name" :value="cm.code" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchParams.start_time"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            style="width: 130px;" />
        </el-form-item>
        <el-form-item>
          <span style="color: #909399;">至</span>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="searchParams.end_time"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 130px;" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" class="search-btn" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-download" class="export-btn" @click="handleExport">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="selectedEligibleIds.length === 0" plain
            @click="handleBulkImmediateGrant">一键审核</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-card">
      <el-table ref="deliveryTable" :data="deliveryData" border fit highlight-current-row style="width: 100%"

        :cell-style="centerCellStyle" :header-cell-style="centerHeaderStyle" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" align="center" :selectable="isRowSelectable" />
        <el-table-column label="用户编号" width="70" align="center">
          <template slot-scope="{row}">
            <span style="cursor: pointer; color: #409EFF;" @click="linkSearchByUserId(row)">{{ row.user_id }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户手机号" width="120" align="center">
          <template slot-scope="{row}">
            <span style="cursor: pointer; color: #409EFF;" @click="linkSearchByPhone(row)">{{ row.user_info &&
              row.user_info.phone ? row.user_info.phone : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="submit_time" label="投递时间" width="150" align="center" />
        <el-table-column label="设备名称" width="120" align="center">
          <template slot-scope="{row}">
            <span style="cursor: pointer; color: #409EFF;" @click="linkSearchByBox(row)">{{ row.box_name || '-'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="原始投递重量(kg)" width="130" align="center">
          <template slot-scope="{row}">{{ computeOriginalWeight(row) }}</template>
        </el-table-column>
        <el-table-column label="应发金额(元)" width="120" align="center">
          <template slot-scope="{row}">{{ computeShouldPay(row) }}</template>
        </el-table-column>
        <el-table-column label="调整重量(kg)" width="100" align="center">
          <template slot-scope="{row}">{{ displayAdjustedWeight(row) }}</template>
        </el-table-column>

        <el-table-column label="投递重量(kg)" width="100" align="center">
          <template slot-scope="{row}">{{ displayDeliveryWeight(row) }}</template>
        </el-table-column>
        <el-table-column label="实发金额(元)" width="110" align="center">
          <template slot-scope="{row}">{{ displayActualAmount(row) }}</template>
        </el-table-column>

        <el-table-column label="投递状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="getStatusType(row.status)" size="small">{{ getStatusName(row.status)
              }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="投递图片" width="120" align="center">
          <template slot-scope="{row}">
            <div v-if="getImageList(row.image).length > 0" class="thumbs">
              <el-image v-for="(img, idx) in getImageList(row.image).slice(0, 3)" :key="idx" :src="getFullImageUrl(img)"
                fit="cover" class="thumb" @click.native.prevent="viewImages(row)" />
              <span v-if="getImageList(row.image).length > 3" class="thumb-more">+{{ getImageList(row.image).length - 3
                }}</span>
            </div>
            <span v-else>补发订单</span>
          </template>
        </el-table-column>
        <el-table-column label="用户投递" width="140" align="center">
          <template slot-scope="{row}">
            <span v-if="getUserStats(row).violation_count > 0">
              <span style="cursor: pointer; color: #F56C6C;" @click="handleClickUserViolation(row)">{{
                getUserStats(row).violation_count }}</span>/<span style="cursor: pointer; color: #409EFF;"
                @click="handleClickUserCompleted(row)">{{ getUserStats(row).total_deliveries }}</span>
            </span>
            <span v-else style="cursor: pointer; color: #409EFF;" @click="handleClickUserCompleted(row)">{{
              getUserStats(row).total_deliveries }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="original_weight" label="投递前重量" width="100" align="center" />
        <el-table-column prop="box_total_weight" label="投递后重量" width="100" align="center" />
        <el-table-column label="清运状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="getAuditTagType(row.status)" size="small">{{ getAuditStatus(row.status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" width="160" align="center" />
        <el-table-column prop="device_code" label="设备编号" width="120" align="center" />
        <el-table-column label="操作" width="240" fixed="right" align="center">
          <template slot-scope="{row}">
            <el-button type="text" size="small" v-if="row.camera_serial_number && row.camera_password"
              @click="handleViewVideo(row)">查看视频</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" v-if="row.status === 4"
              @click="handleCancelDelivery(row)">判定违投</el-button>
            <el-button type="text" size="small" v-if="String(row.status) === '7'"
              @click="openReverseViolationDialog(row)">撤销违投</el-button>
            <el-button type="text" size="small" style="color: #67C23A;" v-if="String(row.status) === '4'"
              @click="handleImmediateGrant(row)">审核</el-button>
            <el-button type="text" size="small" @click="openAdjustWeightDialog(row)">调整重量</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrapper">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="totalDeliveries"
          :page-sizes="[10, 20, 50, 100]" :current-page="pagination.currentPage" :page-size="pagination.page_size"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <!-- 图片预览对话框 -->
    <el-dialog title="图片预览" :visible.sync="imageDialogVisible" width="80%">
      <div class="image-preview-container">
        <el-image v-for="(img, index) in previewImages" :key="index" :src="getFullImageUrl(img)"
          :preview-src-list="previewImages.map(i => getFullImageUrl(i))" fit="contain" class="preview-image" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imageDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 视频播放对话框 -->
    <el-dialog title="查看视频" :visible.sync="videoDialogVisible" width="800px" @close="handleVideoDialogClose">
      <div id="video-container" style="width: 100%; height: 500px;"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="videoDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 判定违投弹窗 -->
    <el-dialog title="判定违投" :visible.sync="violationDialogVisible" width="40%">
      <div class="violation-form">
        <el-alert class="alert-banner" title="订单状态设置成「违规」并扣除该订单的部分重量。" type="warning" :closable="false"
          show-icon></el-alert>
        <el-form :model="violationForm" :rules="violationRules" label-width="100px" ref="violationFormRef">
          <el-form-item label="订单编号">
            <el-input v-model="violationForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input v-model="violationForm.device_code" disabled></el-input>
          </el-form-item>
          <el-form-item label="扣除重量" prop="deductWeight" required>
            <el-input-number v-model="violationForm.deductWeight" :min="0" :max="violationForm.delivery_weight"
              :step="0.1" :precision="2"></el-input-number>
            <el-checkbox v-model="violationForm.deductAll" style="margin-left: 12px;"
              @change="handleDeductAllChange">全部扣除</el-checkbox>
          </el-form-item>
          <el-form-item>
            <div class="metric-line">本单投递量 <span>{{ violationForm.delivery_weight || '-' }}</span> kg</div>
          </el-form-item>
          <el-form-item label="违规原因" prop="remark" required>
            <el-input type="textarea" v-model="violationForm.remark" placeholder="请勿输入Emoji表情"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="violationDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitViolation">确定违规</el-button>
      </div>
    </el-dialog>

    <!-- 调整订单重量弹窗 -->
    <el-dialog title="调整订单重量" :visible.sync="adjustDialogVisible" width="40%">
      <div class="adjust-weight-form">
        <el-tabs v-model="adjustActiveTab">
          <el-tab-pane label="扣除" name="deduct">
            <el-form :model="adjustForm" :rules="adjustRules" label-width="100px" ref="adjustFormRef">
              <el-form-item label="扣除重量" prop="amount">
                <el-input-number v-model="adjustForm.amount" :precision="2"></el-input-number>
              </el-form-item>
              <div class="metric-line">当前订单重量 <span>{{ (currentAdjustRow && currentAdjustRow.delivery_weight) || 0
                  }}</span>
                kg</div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="补重" name="increase">
            <el-form :model="adjustForm" :rules="adjustRules" label-width="100px">
              <el-form-item label="补重" prop="amount">
                <el-input v-model.number="adjustForm.amount" :disabled="isIncreaseDisabled" placeholder="0"
                  type="number" >
                  <template slot="append">kg</template>
                </el-input>
              </el-form-item>
              <div class="adjust-note">只允许正常订单补重</div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adjustDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAdjustWeight">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="撤销违投" :visible.sync="reverseDialogVisible" width="40%">
      <div class="reverse-form">
        <el-form :model="reverseForm" :rules="reverseRules" label-width="100px" ref="reverseFormRef">
          <el-form-item label="订单编号">
            <el-input v-model="reverseForm.id" disabled></el-input>
          </el-form-item>
          <el-form-item label="设备编号">
            <el-input v-model="reverseForm.device_code" disabled></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark" required>
            <el-input type="textarea" v-model="reverseForm.remark" placeholder="请填写撤销原因"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reverseDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitReverseViolation">确认撤销</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeliveries, updateDeliveryStatus, reportDeliveryViolation, reverseDeliveryViolation } from '@/api/deliveries'
import { IMAGE_BASE_URL } from '@/api'
import request from '@/api/interceptor'
import EZUIKit from 'ezuikit-js'
export default {
  name: 'Delivery',
  data() {
    return {
      activeTab: 'all',
      searchParams: {
        deliveryNo: '',
        user_id: '',
        device_code: '',
        box_name: '',
        status_text: '',
        dateRange: [],
        start_time: '',
        end_time: '',
        phone: '',
        group_id: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: ''
      },
      pagination: {
        currentPage: 1,
        page_size: 10
      },
      totalDeliveries: 0,
      successfulDeliveries: 0,
      abnormalDeliveries: 0,
      totalWeight: 0,
      totalAmount: 0,
      deliveryData: [],
      statusDialogVisible: false,
      currentStatusDelivery: null,
      newStatus: '',
      imageDialogVisible: false,
      previewImages: [],
      videoDialogVisible: false,
      currentVideoInfo: null,
      player: null,
      boxGroups: [],
      provinces: [],
      cities: [],
      areas: [],
      streets: [],
      communities: [],
      // 违投判定弹窗
      violationDialogVisible: false,
      violationForm: {
        id: '',
        device_code: '',
        delivery_weight: 0,
        deductWeight: 0,
        deductAll: false,
        remark: '用户违规投放'
      },
      violationRules: {
        deductWeight: [{ required: true, message: '请输入扣除重量', trigger: 'blur' }],
        remark: [{ required: true, message: '请填写违规原因', trigger: 'blur' }]
      },
      adjustDialogVisible: false,
      adjustActiveTab: 'deduct',
      adjustForm: {
        id: '',
        device_code: '',
        amount: 0
      },
      currentAdjustRow: null,
      adjustRules: {
        amount: [
          { required: true, message: '请输入重量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const n = Number(value)
              if (!value || isNaN(n) || n <= 0) {
                callback(new Error('请输入大于 0 的重量'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      },
      reverseDialogVisible: false,
      reverseForm: {
        id: '',
        device_code: '',
        remark: ''
      },
      reverseRules: {
        remark: [{ required: true, message: '请填写撤销原因', trigger: 'blur' }]
      },
      selectedRows: []
      ,
      userStatsByUserId: {}
    }
  },
  computed: {
    isIncreaseDisabled() {
      return this.currentAdjustRow && String(this.currentAdjustRow.status) === '2'
    },
    selectedEligibleIds() {
      if (!Array.isArray(this.selectedRows)) return []
      return this.selectedRows
        .filter(r => String(r && r.status) === '4')
        .map(r => (r && (r.delivery_record_id || r.id || r.delivery_id || r.deliveryId)))
        .filter(Boolean)
    }
  },
  created() {
    this.fetchDeliveries()
    this.fetchBoxGroups()
    this.fetchProvinces()
  },
  mounted() {
    if (!Array.isArray(this.provinces) || this.provinces.length === 0) {
      this.fetchProvinces()
    }
  },
  methods: {
    handleExport() {
      this.$message.info('导出功能待实现')
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows || []
    },
    isRowSelectable(row) {
      return String(row && row.status) === '4'
    },
    async fetchBoxGroups() {
      try {
        const res = await request({ url: '/v1/box-groups', method: 'get', params: { page: 1, page_size: 100 } })
        const outer = res && res.data ? res.data : res
        const inner = outer && outer.data ? outer.data : outer
        const payload = inner && inner.data ? inner.data : inner
        const groups = Array.isArray(payload && payload.groups) ? payload.groups : (Array.isArray(payload && payload.data) ? payload.data : [])
        this.boxGroups = groups
      } catch (e) {
        this.boxGroups = []
      }
    },
    handleTabClick() {
      this.pagination.currentPage = 1;
      this.fetchDeliveries();
    },
    linkSearchByUserId(row) {
      const id = (row && row.user_id) || ''
      this.searchParams.user_id = id
      this.pagination.currentPage = 1
      this.fetchDeliveries()
    },
    linkSearchByPhone(row) {
      const phone = (row && row.user_info && row.user_info.phone) || ''
      this.searchParams.phone = phone
      this.pagination.currentPage = 1
      this.fetchDeliveries()
    },
    linkSearchByBox(row) {
      const name = (row && row.box_name) || ''
      this.searchParams.box_name = name
      this.pagination.currentPage = 1
      this.fetchDeliveries()
    },
    onProvinceChange() {
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
    },
    onCityChange() {
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
    },
    onAreaChange() {
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
    },
    onStreetChange() {
      this.searchParams.community_code = ''
    },
    // 获取投递列表
    async fetchDeliveries() {
      try {
        this.$loading({ text: '加载中...' })

        const statusMap = {
          pending: 4,
          violation: 7,
          processing: 5,
          completed: 8,
          auditing: 6
        }

        // 构建请求参数
        const params = {
          page: this.pagination.currentPage,
          page_size: this.pagination.page_size
        }

        if (this.activeTab === 'overweight') {
          params.min_weight = 5;
        } else if (this.activeTab === 'pending') {
          params.statuss = '4,9';
        } else if (this.activeTab !== 'all') {
          params.status = statusMap[this.activeTab];
        }

        // 映射前端搜索参数到API参数
        if (this.searchParams.deliveryNo) {
          params.deliveryNo = this.searchParams.deliveryNo
        }

        if (this.searchParams.min_weight) {
          params.min_weight = this.searchParams.min_weight
        }
        if (this.searchParams.max_weight) {
          params.max_weight = this.searchParams.max_weight
        }

        if (this.searchParams.user_id) {
          // 将user_id映射到openid参数
          params.user_id = this.searchParams.user_id
        }

        if (this.searchParams.phone) {
          params.phone = this.searchParams.phone
        }

        if (this.searchParams.device_code) {
          params.device_code = this.searchParams.device_code
        }

        if (this.searchParams.box_name) {
          params.box_name = this.searchParams.box_name
        }
        if (this.searchParams.group_id) {
          params.group_id = this.searchParams.group_id
        }

        if (this.searchParams.province_code) {
          params.province_code = this.searchParams.province_code
        }
        if (this.searchParams.city_code) {
          params.city_code = this.searchParams.city_code
        }
        if (this.searchParams.area_code) {
          params.area_code = this.searchParams.area_code
        }
        if (this.searchParams.street_code) {
          params.street_code = this.searchParams.street_code
        }
        if (this.searchParams.community_code) {
          params.community_code = this.searchParams.community_code
        }

        if (this.searchParams.status_text) {
          // 将status_text转换为status参数
          params.status = parseInt(this.searchParams.status_text)
        }

        if (this.searchParams.start_time) {
          params.start_time = this.searchParams.start_time
        }
        if (this.searchParams.end_time) {
          params.end_time = this.searchParams.end_time
        }

        // 删除空参数，保持与设备列表一致
        Object.keys(params).forEach((key) => {
          const val = params[key]
          if (val === '' || val === undefined || val === null || (Array.isArray(val) && val.length === 0)) {
            delete params[key]
          }
        })

        // 调用API获取投递列表
        const response = await getDeliveries(params)

        console.log('API响应数据:', response)

        // 检查响应是否有效
        if (!response) {
          this.$message.error('获取投递列表失败：无效的响应数据')
          return
        }

        // 处理不同格式的响应
        const isSuccess = response.code === 0

        if (isSuccess) {
          if (response.data && response.data.delivery_logs) {
            this.deliveryData = response.data.delivery_logs || []
            this.totalDeliveries = Number(response.data.total) || Number(response.data.total) || 0;
            this.abnormalDeliveries = Number(response.data.violation_count) || 0;
            this.totalWeight = Number(response.data.total_weight) || 0;
            this.totalAmount = Number(response.data.total_amount) || 0;
            await this.loadUserStatsForRows()
          } else {
            this.$message.error('获取投递列表失败：数据格式不正确')
          }
        } else {
          this.$message.error('获取投递列表失败：' + (response.message || '未知错误'))
        }
      } catch (error) {
        console.error('获取投递列表失败:', error)
        this.$message.error('获取投递列表失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },

    // 搜索投递任务
    handleSearch() {
      if (this.searchParams.min_weight && this.searchParams.max_weight) {
        const min = Number(this.searchParams.min_weight)
        const max = Number(this.searchParams.max_weight)
        if (!isNaN(min) && !isNaN(max) && min > max) {
          this.$message.error('最小重量不能大于最大重量')
          return
        }
      }
      this.pagination.currentPage = 1
      this.fetchDeliveries()
      this.$message.success('搜索条件已应用')
    },

    // 重置搜索条件
    handleReset() {
      this.searchParams = {
        deliveryNo: '',
        user_id: '',
        device_code: '',
        device_name: '',
        group_id: '',
        province_code: '',
        city_code: '',
        area_code: '',
        street_code: '',
        community_code: '',
        status_text: '',
        dateRange: [],
        start_time: '',
        end_time: '',
        min_weight: '',
        max_weight: ''
      }
      this.activeTab = 'all'
      this.pagination.currentPage = 1
      this.fetchDeliveries()
      this.$message.info('搜索条件已重置')
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.page_size = size
      this.fetchDeliveries()
    },

    // 当前页码变化
    handleCurrentChange(current) {
      this.pagination.currentPage = current
      this.fetchDeliveries()
    },

    // 获取投递状态名称
    getStatusName(status) {
      const statusMap = {
        '4': '待审核',
        '7': '已违投',
        '5': '审核中',
        '8': '已完成',
        '9': '已完成',
        '6': '审核中'
      }
      return statusMap[status] || status
    },

    // 获取投递状态对应的标签类型
    getStatusType(status) {
      const typeMap = {
        '4': 'info',
        '7': 'danger',
        '5': 'warning',
        '8': 'success',
        '9': 'success',
        '6': 'primary'
      }
      return typeMap[status] || 'default'
    },

    computeShouldPay(row) {
      const dw = Number(row && row.delivery_weight) || 0
      const rw = Number((row && row.reissue_weight) || 0) || 0
      const price = Number((row && (row.recycle_price != null ? row.recycle_price : row.container_recycle_price))) || 0
      const val = (dw - rw) * price
      const num = Number.isFinite(val) ? val : 0
      return num.toFixed(2)
    },
    computeOriginalWeight(row) {
      const dw = Number(row && row.delivery_weight) || 0
      const rw = Number((row && row.reissue_weight) || 0) || 0
      const val = dw - rw
      const num = Number.isFinite(val) ? val : 0
      return (num).toFixed(2)
    },
    computeOriginalWeight1(row) {
      const dw = Number(row && row.delivery_weight) || 0
      const rw = Number((row && row.reissue_weight) || 0) || 0
      const val = dw - rw
      const num = Number.isFinite(val) ? val : 0
      return (num * -1).toFixed(2)
    },
    displayDeliveryWeight(row) {
      if (String(row && row.status) === '7') return '0.00'
      const n = Number(row && row.delivery_weight) || 0
      return n.toFixed(2)
    },
    displayActualAmount(row) {
      if (String(row && row.status) === '7') return '0.00'
      const n = Number(row && row.recycle_amount) || 0
      return n.toFixed(2)
    },
    displayAdjustedWeight(row) {
      if (String(row && row.status) === '7') return this.computeOriginalWeight1(row)
      const n = Number(row && row.reissue_weight) || 0
      return n.toFixed(2)
    },
    getUserStats(row) {
      const uid = (row && row.user_id) || ''
      const s = this.userStatsByUserId && this.userStatsByUserId[uid]
      if (s) return s
      return { violation_count: 0, total_deliveries: 0 }
    },
    async loadUserStatsForRows() {
      const ids = Array.isArray(this.deliveryData) ? Array.from(new Set(this.deliveryData.map(r => r && r.user_id).filter(Boolean))) : []
      const pending = ids.filter(id => !(this.userStatsByUserId && this.userStatsByUserId[id]))
      if (pending.length === 0) return
      const tasks = pending.map(id => this.fetchUserStats(id).then(stats => { this.$set(this.userStatsByUserId, id, stats) }).catch(() => { }))
      await Promise.all(tasks)
    },
    async fetchUserStats(userId) {
      try {
        const res = await request({ url: '/v1/users', method: 'get', params: { page: 1, page_size: 10, user_id: userId } })
        const outer = res && res.data ? res.data : res
        const inner = outer && outer.data ? outer.data : outer
        const list = Array.isArray(inner && (inner.users || inner.data)) ? (inner.users || inner.data) : []
        const first = list.find(u => String(u && (u.user_id || u.id)) === String(userId)) || list[0] || inner
        const violation_count = Number((first && first.violation_count) || (inner && inner.violation_count)) || 0
        const total_deliveries = Number((first && (first.total_deliveries || first.delivery_count)) || (inner && inner.total_deliveries)) || 0
        return { violation_count, total_deliveries }
      } catch (e) {
        return { violation_count: 0, total_deliveries: 0 }
      }
    },
    handleClickUserViolation(row) {
      const uid = (row && row.user_id) || ''
      this.searchParams.user_id = uid
      this.activeTab = 'violation'
      this.pagination.currentPage = 1
      this.fetchDeliveries()
    },
    handleClickUserCompleted(row) {
      const uid = (row && row.user_id) || ''
      this.searchParams.user_id = uid
      this.activeTab = 'completed'
      this.pagination.currentPage = 1
      this.fetchDeliveries()
    },
    async handleImmediateGrant(row) {
      try {
        await this.$confirm('该操作不可逆，确认对该订单进行审核并立即发放吗？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      try {
        this.$loading({ text: '处理中...' })
        const delivery_record_id = row && (row.delivery_record_id || row.id || row.delivery_id || row.deliveryId)
        const res = await request({ url: '/v1/deliveries/immediate-grant', method: 'post', data: { delivery_record_id } })
        const ok = res && (res.code === 0 || res.success === true)
        if (ok) {
          this.$message.success('审核成功，已立即发放')
          this.fetchDeliveries()
        } else {
          this.$message.error('审核失败：' + (res && (res.message || res.msg) || '未知错误'))
        }
      } catch (e) {
        this.$message.error('审核失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },
    async handleBulkImmediateGrant() {
      const ids = this.selectedEligibleIds
      if (!ids || ids.length === 0) {
        this.$message.warning('请选择状态为「待清运」的订单进行审核')
        return
      }
      try {
        await this.$confirm(`将批量审核 ${ids.length} 个订单，操作不可逆，是否继续？`, '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const loader = this.$loading({ text: '批量处理中...' })
      let success = 0
      let failed = 0
      try {
        for (const delivery_record_id of ids) {
          try {
            const res = await request({ url: '/v1/deliveries/immediate-grant', method: 'post', data: { delivery_record_id } })
            const ok = res && (res.code === 0 || res.success === true)
            if (ok) success++
            else failed++
          } catch (e) {
            failed++
          }
        }
        this.$message.success(`处理完成：成功 ${success} 条，失败 ${failed} 条`)
        this.fetchDeliveries()
        if (this.$refs.deliveryTable && this.$refs.deliveryTable.clearSelection) {
          this.$refs.deliveryTable.clearSelection()
        }
      } finally {
        loader.close()
      }
    },
    getAuditStatus(status) {
      const s = String(status)
      if (s === '4') return '未清运'
      if (s === '9') return '未清运'
      if (s === '5') return '清运中'
      return '已清运'
    },
    getAuditTagType(status) {
      const s = String(status)
      if (s === '4') return 'info'
      if (s === '9') return 'info'
      if (s === '5') return 'warning'
      return 'success'
    },
    getSettlementStatus(status) {
      const s = String(status)
      if (s === '7' || s === '8') return '已结算'
      return '未结算'
    },
    getSettlementTagType(status) {
      const s = String(status)
      if (s === '7' || s === '8') return 'success'
      return 'warning'
    },

    // 打开更新状态对话框
    openUpdateStatusDialog(row) {
      this.currentStatusDelivery = row
      this.newStatus = row.status
      this.statusDialogVisible = true
    },

    // 更新投递状态
    async handleUpdateStatus() {
      if (!this.currentStatusDelivery || !this.newStatus) {
        this.$message.error('请选择有效的状态')
        return
      }

      try {
        this.$loading({ text: '更新中...' })
        const deliveryId = this.currentStatusDelivery.id || this.currentStatusDelivery.deliveryId
        const response = await updateDeliveryStatus(deliveryId, { status: parseInt(this.newStatus) })

        if (response && (response.success || response.code === 0 || response.code === 'SUCCESS' || response.code === 200)) {
          this.$message.success('状态更新成功')
          this.statusDialogVisible = false
          // 重新获取投递列表
          this.fetchDeliveries()
        } else {
          this.$message.error('更新状态失败：' + (response.message || response.msg || '未知错误'))
        }
      } catch (error) {
        console.error('更新状态失败:', error)
        this.$message.error('更新状态失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },

    // 打开违投判定弹窗
    handleCancelDelivery(row) {
      this.violationForm.id = row.id || row.deliveryId || ''
      this.violationForm.device_code = row.device_code || ''
      this.violationForm.delivery_weight = row.delivery_weight || 0
      this.violationForm.deductWeight = 0
      this.violationForm.deductAll = false
      this.violationForm.remark = this.violationForm.remark || '用户违规投放'
      this.violationDialogVisible = true
    },

    openAdjustWeightDialog(row) {
      this.currentAdjustRow = row
      this.adjustForm.id = row.id || row.deliveryId || ''
      this.adjustForm.device_code = row.device_code || ''
      this.adjustForm.amount = 0
      this.adjustActiveTab = 'deduct'
      this.adjustDialogVisible = true
    },

    handleDeductAllChange(value) {
      if (value) {
        this.violationForm.deductWeight = this.violationForm.delivery_weight
      } else {
        this.violationForm.deductWeight = 0
      }
    },

    // 查看视频
    handleViewVideo(row) {
      this.currentVideoInfo = row;
      this.videoDialogVisible = true;
      this.$nextTick(() => {
        this.initPlayer();
      });
    },

    // 初始化播放器
    initPlayer() {
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
      const { camera_serial_number, camera_password, start_time, end_time } = this.currentVideoInfo;
      const accessToken = localStorage.getItem('ys_token');
      console.log(accessToken)
      console.log('at.6i2s1jeg5zkwkwuzbhnf1lji11me5y4b-5fl19hccwt-16r6qo5-hfyavtqva')
      // 格式化时间
      const formatTime = (timeStr) => timeStr.replace(/[-: ]/g, '');
      const beginTime = formatTime(start_time);
      const endTime = formatTime(end_time);
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'video-container',
        accessToken,
        url: `ezopen://${camera_password}@open.ys7.com/${camera_serial_number}/1.rec?begin=${beginTime}&end=${endTime}`,
        template: 'simple', // simple, standard, security
      });
    },

    // 关闭视频弹窗时销毁播放器
    handleVideoDialogClose() {
      if (this.player) {
        this.player.destroy();
        this.player = null;
      }
    },

    // 提交违投判定
    async submitViolation() {
      if (!this.violationForm.id) {
        this.$message.error('缺少订单编号')
        return
      }
      const valid = await new Promise(resolve => {
        if (!this.$refs.violationFormRef) return resolve(true)
        this.$refs.violationFormRef.validate(v => resolve(v))
      })
      if (!valid) return
      const dw = Number(this.violationForm.deductWeight) || 0
      const total = Number(this.violationForm.delivery_weight) || 0
      if (dw <= 0) {
        this.$message.error('扣除重量必须大于 0')
        return
      }
      if (dw > total) {
        this.$message.error('扣除的重量不可超过当前投递重量')
        return
      }
      try {
        this.$loading({ text: '提交中...' })
        const reissue_weight = this.violationForm.deductAll ? 0 : -Math.abs(Number(this.violationForm.deductWeight) || 0)
        const payload = {
          id: this.violationForm.id,
          device_code: this.violationForm.device_code,
          remark: this.violationForm.remark,
          reissue_weight
        }
        const response = await reportDeliveryViolation(payload)
        if (response && (response.success || response.code === 0 || response.code === 'SUCCESS' || response.code === 200)) {
          this.$message.success('已判定违投')
          this.violationDialogVisible = false
          this.fetchDeliveries()
        } else {
          this.$message.error('提交失败：' + (response.message || response.msg || '未知错误'))
        }
      } catch (error) {
        console.error('提交违投失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },

    async submitAdjustWeight() {
      if (!this.adjustForm.id) {
        this.$message.error('缺少订单编号')
        return
      }
      const type = this.adjustActiveTab === 'increase' ? 'increase' : 'deduct'
      if (type === 'increase' && this.isIncreaseDisabled) {
        this.$message.error('违规订单不允许补重')
        return
      }
      const amount = Number(this.adjustForm.amount) || 0
      if (amount <= 0) {
        this.$message.error('请输入大于 0 的重量')
        return
      }
      if (type === 'deduct') {
        const current = Number(this.currentAdjustRow && this.currentAdjustRow.delivery_weight) || 0
        if (amount > current) {
          this.$message.error('扣重不可超过当前订单重量')
          return
        }
      }
      try {
        this.$loading({ text: '提交中...' })
        const delta = Math.abs(Number(this.adjustForm.amount) || 0)
        const reissue_weight = type === 'increase' ? delta : -delta
        const payload = {
          id: this.adjustForm.id,
          device_code: this.adjustForm.device_code,
          remark: type === 'increase' ? '增加重量' : '扣除重量',
          reissue_weight
        }
        const response = await reportDeliveryViolation(payload)
        if (response && (response.success || response.code === 0 || response.code === 'SUCCESS' || response.code === 200)) {
          this.$message.success('重量调整成功')
          this.adjustDialogVisible = false
          this.fetchDeliveries()
        } else {
          this.$message.error('提交失败：' + (response.message || response.msg || '未知错误'))
        }
      } catch (error) {
        console.error('调整重量失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },

    openReverseViolationDialog(row) {
      this.reverseForm.id = row.id || row.deliveryId || ''
      this.reverseForm.device_code = row.device_code || ''
      this.reverseForm.remark = ''
      this.reverseDialogVisible = true
    },

    async submitReverseViolation() {
      if (!this.reverseForm.id) {
        this.$message.error('缺少订单编号')
        return
      }
      const valid = await new Promise(resolve => {
        if (!this.$refs.reverseFormRef) return resolve(true)
        this.$refs.reverseFormRef.validate(v => resolve(v))
      })
      if (!valid) return
      try {
        this.$loading({ text: '提交中...' })
        const payload = {
          id: this.reverseForm.id,
          device_code: this.reverseForm.device_code,
          remark: this.reverseForm.remark
        }
        const response = await reverseDeliveryViolation(payload)
        if (response && (response.success || response.code === 0 || response.code === 'SUCCESS' || response.code === 200)) {
          this.$message.success('撤销违投成功')
          this.reverseDialogVisible = false
          this.fetchDeliveries()
        } else {
          this.$message.error('提交失败：' + (response.message || response.msg || '未知错误'))
        }
      } catch (error) {
        console.error('撤销违投失败:', error)
        this.$message.error('提交失败，请稍后重试')
      } finally {
        this.$loading().close()
      }
    },

    // 处理图片列表
    getImageList(imageStr) {
      if (!imageStr) return []
      try {
        // 去除字符串前后的空格和引号
        const cleanStr = imageStr.trim().replace(/^["']|["']$/g, '')
        if (!cleanStr) return []

        // 尝试解析JSON数组
        const images = JSON.parse(cleanStr)
        return Array.isArray(images) ? images : []
      } catch (error) {
        console.warn('解析图片列表失败:', error)
        return []
      }
    },

    // 获取完整图片URL
    getFullImageUrl(imagePath) {
      if (!imagePath) return ''
      return imagePath.startsWith('http') ? imagePath : IMAGE_BASE_URL + imagePath
    },

    // 查看图片
    viewImages(row) {
      const images = this.getImageList(row.image)
      if (images.length === 0) {
        this.$message.info('暂无图片')
        return
      }

      // 打开图片预览对话框
      this.previewImages = images
      this.imageDialogVisible = true
    },

    // 列表内容居中样式
    centerCellStyle() {
      return { textAlign: 'center' }
    },
    centerHeaderStyle() {
      return { textAlign: 'center' }
    },
    async fetchProvinces() {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get' })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.provinces = list
      } catch (e) {
        this.provinces = []
      }
    },
    async fetchCities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.cities = list
      } catch (e) {
        this.cities = []
      }
    },
    async fetchAreas(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.areas = list
      } catch (e) {
        this.areas = []
      }
    },
    async fetchStreets(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.streets = list
      } catch (e) {
        this.streets = []
      }
    },
    async fetchCommunities(code) {
      try {
        const res = await request({ url: '/v1/divisions', method: 'get', params: { code } })
        const body = res && res.data ? res.data : res
        const list = Array.isArray(body) ? body : (Array.isArray(body && body.data) ? body.data : [])
        this.communities = list
      } catch (e) {
        this.communities = []
      }
    },
    onProvinceSelect(code) {
      this.searchParams.city_code = ''
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.cities = []
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchCities(code)
    },
    onCitySelect(code) {
      this.searchParams.area_code = ''
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.areas = []
      this.streets = []
      this.communities = []
      if (code) this.fetchAreas(code)
    },
    onAreaSelect(code) {
      this.searchParams.street_code = ''
      this.searchParams.community_code = ''
      this.streets = []
      this.communities = []
      if (code) this.fetchStreets(code)
    },
    onStreetSelect(code) {
      this.searchParams.community_code = ''
      this.communities = []
      if (code) this.fetchCommunities(code)
    },

  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background-color: #f0f2f5;
  padding: 20px;
}

.tabs-bg {
  background: #fff;
  padding: 10px 20px 0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.summary-bar {
  background: #e6f1fc;
  border-radius: 8px;
  padding: 10px 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.summary-header {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.summary-header .dot {
  width: 8px;
  height: 8px;
  background: #28b652;
  border-radius: 50%;
  margin-right: 8px;
}

.summary-header .title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.summary-content {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
}

.summary-item {
  text-align: center;
  flex: 1;
  margin-left: 0;
}

.summary-item .value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 2px;
}

.summary-item .label {
  font-size: 12px;
  color: #666;
}

.search-card {
  background: #fff;
  padding: 18px 10px 0;
  border-radius: 4px;
  margin-bottom: 10px;
}

.filter-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 5px;
}

.search-btn {
  background-color: #28b652;
  border-color: #28b652;
  color: #fff;
}

.export-btn {
  color: #28b652;
  border-color: #28b652;
  background-color: #f0f9eb;
}

.table-card {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  min-height: 500px;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.thumbs {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
}

.thumb {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
}

.thumb-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #f5f7fa;
  color: #909399;
  border-radius: 4px;
  font-size: 12px;
}

.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.violation-form, .adjust-weight-form, .reverse-form {
  padding: 0 20px;
}

.metric-line {
  margin-top: 5px;
  color: #909399;
  font-size: 13px;
}

.metric-line span {
  color: #303133;
  font-weight: 500;
  margin: 0 4px;
}

.adjust-note {
  margin-top: 10px;
  color: #F56C6C;
  font-size: 12px;
}
</style>
